// extracted by mini-css-extract-plugin
export default {"container":"styles_container__VpGYf","logo":"styles_logo__F0kxO"};